import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class VueHooksInfoMixin extends Vue {
  isMounted = false

  mounted() {
    this.isMounted = true
  }
}

export default toNative(VueHooksInfoMixin)
